import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { createSelector } from '@reduxjs/toolkit'
import { Grid } from '@mui/material'
import { Project } from '../../models/Organization'
import FileCardComponent from './FileCardComponent'
import { useEffect } from 'react'
import { updateSelectedFile } from '../../actions/organization'
import StartNewFileInProjectComponent from './StartNewFileInProjectComponent'
import { useLocation } from 'react-router-dom'

interface FilesListProps {
  project: Project
}

const filesSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.files,
)
const selectedFileSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.selectedFile,
)

const FilesListComponent: React.FC<FilesListProps> = ({ project }) => {
  const dispatch = useDispatch<any>()
  const files = useSelector(filesSelector)
  const selectedFile = useSelector(selectedFileSelector)
  const location = useLocation()

  useEffect(() => {
    if (location.state?.from !== 'recentFile') {
      dispatch(updateSelectedFile(undefined))
    }
  }, [])

  return (
    <Grid
      container
      spacing={'1rem'}
      sx={{
        overflowY: 'auto',
        boxSizing: 'border-box',
        pb: '1rem',
      }}
    >
      <Grid size={4}>
        <StartNewFileInProjectComponent />
      </Grid>
      {files
        .filter((file) => file.project_id === project.id)
        .map((file, index) => (
          <Grid
            key={index}
            size={4}
            sx={{
              border:
                selectedFile?.id === file.id
                  ? '2px solid #1705E5'
                  : '2px solid transparent',
              borderRadius: '0.4rem',
              '&:hover': {
                border: '2px solid #1705E5',
              },
            }}
          >
            <FileCardComponent file={file} />
          </Grid>
        ))}
    </Grid>
  )
}

export default FilesListComponent
